export default (reportType) => {
  const reportList = {
    generalReport: 'Сводный',
    ticketReport: 'По талонам',
    dailyWorkloadReport: 'Нагрузка по дням',
    operatorReport: 'По операторам',
    queueReport: 'По очередям',
    workPlaceReport: 'По рабочим местам',
    groupReport: 'Групповой',
    clockwiseReport: 'Почасовой',
    dynamicsServiceTime: 'Динамика',
    operatorLogi: 'Логи операторов',
    audioRecord: 'Записи',
    surveyReport: 'По дополнительным полям',
    preEntryReport: 'Предварительная запись',
    sourceReport: 'По источнику',
    solvedQuestionReport: 'По решенным вопросам',
    timeСonsumption: 'Расход рабочего времени',
    ticketClosePieChart: 'Распределение талонов по очередям',
    ticketRestore: 'Восстановление талонов',
  };

  return reportList[reportType];
};
